import React from 'react';
import { Input, Button, TitleModalRight, CheckboxTable, PaperClip } from 'components';
import { OperatorService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';

interface Props {
	onClose?: any;
	item?: any;
}

class ModalOperators extends React.Component<Props> {

	state = {
		
	}
	
	render() {
		return (
			<div id="modal-quotes-operators">
				{
					this.props.item?.operators?.map((item: any) => {
						return (
							<div className="item-operator">
								<img src={ Constants.BASE_STORAGE + item.operator?.photo } />
								<div>
									<p className="name">{ item.operator?.full_name }</p>
									{ item.operator?.services?.length > 0 && <p className="services">{ item.operator?.services?.filter((i: any) => i.service?.name).map((i: any) => i.service?.name).join(', ') }</p> }
								</div>
							</div>
						)
					})
				}

				{
					this.props.item?.operators?.length == 0 && (
						<p className="no-data">No se encontraron operarios</p>
					)
				}

				<div className="text-center">
					<button className="btn btn-cancel" onClick={ () => this.props.onClose() }>
						Cerrar
					</button>
				</div>
			</div>
		)
	}
}

export default ModalOperators;